import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug?: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Link
        to="/"
        className={`px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-all duration-200 cursor-pointer ${
          !activeSlug
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
        }`}
      >
        全部文章
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-all duration-200 cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}